module.exports = __webpack_public_path__ + "img/risk-bg.06bfe2d7.jpg";